import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { Context } from "contexts/contextState";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { errorAlert, successAlert } from "views/components/Alerts";

export function DeleteCustomerModal(props) {
  const { context } = useContext(Context);
  const [processing, setProcessing] = useState(false);

  async function handleDeleteCustomer() {
    setProcessing(true);
    try {
      await context.userRepository.delete(props.customer.id);
      successAlert("Success!", "The customer has been deleted.").then(() => {
        window.location.reload();
      });
      props.onClose();
    } catch (error) {
      console.log("handleDeleteCustomer", error);
      errorAlert("Error!", "Failed to delete a customer in our database. Please check your connection and try again. If the issue persists, please contact our support team for assistance.");
    } finally {
      setProcessing(false);
    }
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>
        Are you certain you want to delete this customer?
      </DialogTitle>
      <DialogContent>
        <SoftTypography variant="body2">
          If you delete this customer <b>{((props.customer?.firstName || "") + " " + (props.customer?.lastName || "")).trim()}</b>, it cannot be recovered. <br />Are you sure you want to proceed?
        </SoftTypography>
        <br />
        <SoftTypography variant="body2">
          Click the <b>Delete</b> button to confirm or <b>Cancel</b> to go back.
        </SoftTypography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" flex="1">
          <SoftButton variant="text" color="error"
            onClick={handleDeleteCustomer}
            disabled={!(context.permission?.root || context.permission?.customer?.delete)}
          >
            Delete
          </SoftButton>
          <SoftButton variant="text" color="info" onClick={props.onClose} disabled={processing}>Cancel</SoftButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

DeleteCustomerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired,
};